const getTextContent = (parent: Element): string | null => {
  const elements = Array.from(
    parent.querySelectorAll('[data-element-name="RichText"] .content'),
  );
  const content = elements
    .map((el) => el.textContent?.trim() ?? "")
    .filter((text) => text.length > 0)
    .join("\n");
  return content.length > 0 ? content : null;
};

const findContentInHierarchy = (
  startElement: Element | null,
  ancestorTypes: string[],
): string | null => {
  if (!startElement) return null;

  let content = getTextContent(startElement);
  if (content) return content;

  for (const type of ancestorTypes) {
    const ancestor = startElement.closest(`[data-layer-type="${type}"]`);
    if (ancestor) {
      content = getTextContent(ancestor);
      if (content) return content;
    }
  }
  return null;
};

export const getClosestTextContent = (): string | null => {
  const container = document.getElementById("content-sgKecQsAYKy7MX4");
  if (!container) return null;

  const activeSlide = container.querySelector(
    '.--active[data-layer-type="slide"]',
  );
  if (activeSlide) {
    const slideContent = getTextContent(activeSlide);
    if (slideContent) return slideContent;
  }

  const searchScopes: [string, string[]][] = [
    ["element", ["group", "set", "combo", "slide"]],
    ["group", ["set", "combo", "slide"]],
    ["set", ["combo", "slide"]],
    ["combo", ["slide"]],
  ];

  for (const [startFrom, ancestorTypes] of searchScopes) {
    const activeElement = container.querySelector(
      `.--active[data-layer-type="${startFrom}"]`,
    );
    if (activeElement) {
      const content = findContentInHierarchy(activeElement, ancestorTypes);
      if (content) {
        return content;
      }
      break;
    }
  }

  return null;
};
